import * as React from 'react'
import {Lang} from 'yougile-lang'
import {Util} from 'yougile-util'
import {TrackingEvent} from '@common/tracking-events'
import {Button} from '@components/common/base/buttons'
import {Tracking} from '../../../common/tracking'
import {setDisplayName} from '../../../common/utils-ui'
import {useInput} from '../../containers/hooks'
import {BillingProps, calcTotal} from './billing-base'

export const BillingPayInvoice = (props: BillingProps) => {
  const {license, onChange, onRequestInvoice} = props
  const bem = Util.bemFrom('billing')
  const total = calcTotal(props)
  const phoneChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    void Tracking.send(TrackingEvent.billingChangeLicenseClick)
    onChange({...license, phone: e.target.value})
  }
  const emailChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    void Tracking.send(TrackingEvent.billingChangeLicenseClick)
    onChange({...license, email: e.target.value})
  }

  const [fullName, changeFullName] = useInput('')
  const [address, changeAddress] = useInput('')
  const [tin, changeTin] = useInput('')
  const [trrc, changeTrrc] = useInput('')
  const [accNum, changeAccNum] = useInput('')
  const [corrAccNum, changeCorrAccNum] = useInput('')
  const [rcbic, changeRcbic] = useInput('')

  const submit = () => {
    onRequestInvoice({
      fullName,
      address,
      tin,
      trrc,
      accNum,
      corrAccNum,
      rcbic
    })
  }
  const requisite = (
    value: string,
    change: (e: {target: {value: string}}) => void,
    label: string,
    placeholder: string
  ) => {
    return (
      <label className={bem('pay-label')}>
        {label}:
        <input
          className={bem('pay-input')}
          type="text"
          placeholder={placeholder}
          value={value}
          onChange={change}
          onKeyDown={onKeyDown}
        />
      </label>
    )
  }

  const hide = license.paymentMethod !== 'invoice'
  if (hide) {
    return (
      <div
        className={bem('pay-block', {
          bill: true,
          hide: true
        })}
      />
    )
  }

  return (
    <div
      className={bem('pay-block', {
        bill: true
      })}
    >
      {!license.success && (
        <>
          {requisite(fullName, changeFullName, Lang.msg.bill.fullName, '')}
          {requisite(address, changeAddress, Lang.msg.bill.address, '')}
          {requisite(tin, changeTin, Lang.msg.bill.tin, '')}
          {requisite(trrc, changeTrrc, Lang.msg.bill.trrc, '')}
          {requisite(accNum, changeAccNum, Lang.msg.bill.accNum, '')}
          {requisite(
            corrAccNum,
            changeCorrAccNum,
            Lang.msg.bill.corrAccNum,
            ''
          )}
          {requisite(rcbic, changeRcbic, Lang.msg.bill.rcbic, '')}
          <label className={bem('pay-label')}>
            {Lang.msg.phone}:
            <input
              className={bem('pay-input')}
              type="text"
              placeholder={Lang.msg.phonePl}
              value={license.phone}
              onChange={phoneChange}
              onKeyDown={onKeyDown}
            />
          </label>
          <label className={bem('pay-label')}>
            {Lang.msg.email}:
            <input
              className={bem('pay-input')}
              type="email"
              placeholder={Lang.msg.emailPl}
              value={license.email}
              onChange={emailChange}
              onKeyDown={onKeyDown}
            />
          </label>
          <div className={bem('pay-total')}>
            {Lang.msg.billingTotal}:
            <div className={bem('pay-amount')}>
              {total || '—'}{' '}
              <div className={bem('pay-rub')}>{Lang.msg.rub}</div>
            </div>
          </div>
          <Button className="mt-14" onClick={submit} disabled={license.wait}>
            {Lang.msg.billingGetInvoice}
          </Button>
        </>
      )}
      {license.success && (
        <div className={bem('success')}>
          {Lang.msg.done}.<br />
          {Lang.msg.billingInvoiceSentReq}
        </div>
      )}
    </div>
  )
}
setDisplayName(BillingPayInvoice, 'BillingPayInvoice')

const onKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
  if (e.code === 'Escape') {
    const el = e.target as HTMLElement
    el.blur()
    e.stopPropagation()
  }
}
